export default __webpack_public_path__ + "static/media/forwardArrow.2fde57d0.svg";